<template>
  <div class="home">
    <main-layout />
    <cards-screen />
    <our-product class="md:mt-24" />
    <pricing v-if="!matchEntities(['NETHERLANDS'])" :tariffRef="$refs" />
    <Accreditations v-if="enabledAccreditations()" />
    <ThirdPartyCTA v-if="matchEntities(['GERMANY'])" />
    <our-focus />
    <NetherlandsFormCTA :displayLearnMoreLink="true" />
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue';
import MainLayout from '@/components/HomePage/StartScreen/StartScreen.vue';
import CardsScreen from '@/components/HomePage/CardsScreen/CardsScreen.vue';
import OurProduct from '@/components/HomePage/OurProduct/OurProduct.vue';
import Pricing from '@/components/HomePage/Pricing.vue';
import Accreditations from '@/components/HomePage/Accreditations.vue';
import OurFocus from '@/components/HomePage/OurFocus.vue';
import NetherlandsFormCTA from '../components/HomePage/NetherlandsFormCTA.vue';
import ThirdPartyCTA from '../components/HomePage/ThirdPartyCTA.vue';
import matchEntities from '../shared/entityHelpers';
import featureFlags from '../../utils/featureFlags';

export default {
  name: 'Home',
  components: {
    MainLayout,
    CardsScreen,
    OurProduct,
    Pricing,
    Accreditations,
    OurFocus,
    NetherlandsFormCTA,
    ThirdPartyCTA,
  },
  methods: {
    matchEntities,
    enabledAccreditations: featureFlags.enabledAccreditations,
  },
};
</script>
